import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PropTypes from "prop-types";

import useThemeRender from "../../../theme/useThemeRender";

const FileView = ({ onPreview, fileDocument, onDelete, disabled = false }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: { xs: "100%"},
        height: { sm: "32px" },
        background: useThemeRender("insideCardBackgroundColorLayer3"),
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={onPreview}
      >
        <InsertDriveFileOutlinedIcon
          fontSize="small"
          sx={{ marginRight: 1, color: "primary.main" }}
        />
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "inherit",
            lineHeight: "18px",
          }}
        >
          {fileDocument.name}
        </Typography>
      </Box>
      <IconButton
        disabled={disabled}
        onClick={() => onDelete(fileDocument.fileId)}
      >
        <DeleteOutlineOutlinedIcon
          fontSize="small"
          color="primary"
        />
      </IconButton>
    </Box>
  );
};

FileView.propTypes = {
  fileDocument: PropTypes.object,
  onPreview: PropTypes.func,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FileView;
